import { DeliveryLocation } from '~/App/shared/interfaces/DeliveryLocation';
import { Facility } from '~/App/shared/interfaces/Facility';

export const formatDeliveryAddress = (
  location: DeliveryLocation | null | undefined
): string => {
  if (!location) return '';

  const street = [location.streetName, location.streetNumber]
    .filter(Boolean)
    .join(' ');
  const cityLine = [location.zipCode, location.city].filter(Boolean).join(' ');
  const isForeign = location.country && location.country.toLowerCase() !== 'se';

  return [street, cityLine, isForeign && location.countryLongName]
    .filter(Boolean)
    .join(', ');
};

export const formatFacilityAddress = (
  facility: Pick<Facility, 'address' | 'postCode' | 'city'>
): string => {
  const cityLine = [facility.postCode, facility.city].filter(Boolean).join(' ');
  return [facility.address, cityLine].filter(Boolean).join(', ');
};
